import React from 'react';
import ReactDOM from 'react-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';

import { store } from './store';

const theme = createTheme({
  palette: {
    // type: 'dark',
    primary: {
      // light: '#757ce8',
      main: '#234378', //'#3f50b5',
      // dark: '#002884',
      // contrastText: '#fff',
    },
    secondary: {
      // light: '#ff7961',
      main: '#B32034',
      // dark: '#ba000d',
      // contrastText: '#000',
    },
    table: {
      head: '#333',
      row: 'rgba(63, 80, 181, 0.1)',
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ToastContainer
          position="bottom-left"
          autoClose={4000}
          hideProgressBar={true}
          closeOnClick={true}
          // pauseOnHover={true}
          draggable={true}
          style={{ maxWidth: 300, left: 'unset'}}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <App />
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
